import './form.scss';

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from '../../../interfaces';

export interface FormFooterProps {
    submitLabel?: string;
    cancelLabel?: string;
    onSubmit?: () => void;
    onCancel?: () => void;
    history?: IHistory;
    pathName?: string;
}

export class FormFooterImpl extends React.PureComponent<FormFooterProps, {}> {
    constructor(props: FormFooterProps) {
        super(props);
    }

    handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        } else {
            const path = this.props.pathName.split('/');
            path.pop();
            this.props.history.push(`/home`);
        }
    }

    render() {
        return <div className="form-footer" >
            <button type="button" onClick={this.handleCancel} className="cancel-button" >
                {this.props.cancelLabel || 'Cancel'}
            </button>
            <button className="submit-button" onClick={this.props.onSubmit} >
                {this.props.submitLabel || 'Submit'}
            </button>
        </div >;
    }

}

export function mapStateToProps(state, ownProps) {
    return {
        pathName: ownProps.location.pathname
    };
}

export const FormFooter = withRouter(connect<{}, {}, FormFooterProps>(mapStateToProps)(FormFooterImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/FormFooter.tsx